/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Property } from "app/models/property";
import { TagService } from "app/services/tag.service";


@Injectable({providedIn: 'root'})
export class TagPropertiesMainDisplayResolver implements Resolve<Property[]> {

  constructor(
    private tagService: TagService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Property[]> {
    try {
        return this.tagService.getAllTagPropertiesForMainDisplay();
    } catch (error) {
        console.error("Problem obtaining Tag Properties for Main Display...", error);
        return [];
    }
  }

}
